import { render, staticRenderFns } from "./xtsz.vue?vue&type=template&id=28459703&scoped=true"
import script from "./xtsz.vue?vue&type=script&lang=js"
export * from "./xtsz.vue?vue&type=script&lang=js"
import style0 from "./xtsz.vue?vue&type=style&index=0&id=28459703&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28459703",
  null
  
)

export default component.exports